// This file is automatically compiled by esbuild, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/assets/javascript and only use these files to reference
// that code so it'll be compiled.
import "core-js";
import smoothscroll from "smoothscroll-polyfill";
import "regenerator-runtime/runtime";
import "./controllers";
import "whatwg-fetch";
import { default as apply_element_closest_polyfill } from "element-closest";
import Rails from "@rails/ujs";
import handleSweetAlertConfirm from "./lib/sweet_alerts";

if (!window._rails_loaded) {
  Rails.delegate(
    document,
    "a[data-confirm-swal]",
    "click",
    handleSweetAlertConfirm,
  );
  Rails.delegate(
    document,
    "button[data-confirm-swal]:not([form])",
    "click",
    handleSweetAlertConfirm,
  );
  Rails.start();
}
require("trix");
require("@rails/actiontext");
require("@rails/activestorage").start();
require("./lib/action_text_overrides");
require("./lib/polyfills/element-remove");
require("turbolinks").start();

apply_element_closest_polyfill(window); // Run polyfill setup
smoothscroll.polyfill(); // Run polyfill setup
